<template>
  <transition name="modal">
    <div class="modal-mask">
        <div class="modal-container">

  <header class="game-definition-form-header">
    <h1>New Game</h1>
    <p><em>Describe your game and how it is played.</em></p>
  </header>

  <form @submit.prevent="handleSubmit" class="game-definition-form">
    <div class="form-row">
      <label for="full-name">Name</label>
      <input id="full-name" name="full-name" type="text" v-model='name'/>
    </div>
    <fieldset class="legacy-form-row">
      <legend>Scored by</legend>
      <div class="labeled-radio">
        <input id="scoringType-2" name="scoringType" type="radio" value="ROUNDS" checked v-model='scoringType'/>
        <label for="scoringType-2" class="radio-label">Rounds</label>
      </div>
      <div class="labeled-radio">
        <input id="scoringType-1" name="scoringType" type="radio" value="TURNS" v-model='scoringType'/>
        <label for="scoringType-1" class="radio-label">Player Turn</label>
      </div>
    </fieldset>
    <fieldset class="legacy-form-row">
      <legend>Winning Score</legend>
      <div class="labeled-radio">
        <input id="winningScoreType-1" name="winningScoreType" type="radio" value="HIGH_SCORE" checked v-model='winnigScoreType'/>
        <label for="winningScoreType-1" class="radio-label">High Score</label>
      </div>
      <div class="labeled-radio">
        <input id="winningScoreType-2" name="winningScoreType" type="radio" value="LOW_SCORE" v-model='winnigScoreType' />
        <label for="winningScoreType-2" class="radio-label">Low Score</label>
      </div>
    </fieldset>
    <div class="form-row">
      <label for="completionType">Game Ends</label>
      <select id="completionType" name="completionType" v-model='gameCompletionCriteria'>
        <option v-bind:value="{ completionType: 'FIXED_ROUNDS' }">Number of Rounds</option>
        <option v-bind:value="{ completionType: 'PLAYER_OUT' }" >First Player Out</option>
        <option v-bind:value="{ completionType: 'TARGET_SCORE' }" >Score Attained</option>
      </select>
    </div>
    <div class="form-row" id="amount-fields" ref='amount_fields'>
      <label for="amount">Amount</label>
      <input id="amount" name="amount" type="number" v-model.number='amount'/>
    </div>
    <div class="form-row">
      <label class="checkbox-label" for="auto-advancing">
        <input id="auto-advancing" name="autoAdvancing" type="checkbox" value="autoAdvancing"  v-model='autoAdvancing' />
        <span> Rounds/Turns Automatically Advance</span>
      </label>
    </div>
    <div class="form-row">
      <label for="tags">Tags</label>
              <vue-tags-input
          v-model="tag"
          :placeholder='"add tag"'
          :tags="tags"
          @tags-changed="newTags => tags = newTags"
        />
    </div>
    <div class="form-row">
      <button  @click="$emit('cancel')">Cancel</button>
      <button :disabled="name.length == 0" @click="$emit('close')">Submit</button>
    </div>
  </form>
          
        </div>
    </div>
  </transition>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';
import gamedefinitions from "../../api/game-definitions";

export default {
    name: 'game-definition',
    components: {
        VueTagsInput
    },
    data() {
        return {
            name:'',
            scoringType: 'ROUNDS',
            winnigScoreType: 'HIGH_SCORE',
            gameCompletionCriteria: {
                completionType: 'FIXED_ROUNDS',
            },
                amount: 0,
            autoAdvancing: false,
            tags: [],
            tag: ''
        }
    },
    methods: {
        handleSubmit() {
            const newDefinition = {
                name:this.name,
                scoringType: this.scoringType,
                winningScoreType: this.winnigScoreType,
                gameCompletionCriteria: {
                    completionType: this.gameCompletionCriteria.completionType,
                    amount: this.amount
                },
                autoAdvancing: this.autoAdvancing,
                tags: this.tags.map(tag => tag.text)
            }
                this.$emit('game-definition-added', newDefinition)

            gamedefinitions.addGameDefinition(newDefinition, (gameDefinition) => {
                this.$emit('game-definition-added', gameDefinition)
            }, (error) => {
                /* eslint-disable no-console */
                console.log('ERROR ' + error + ' adding ' + newDefinition)
                /* eslint-enable no-console */
            });
        }
    },
    watch: {
        gameCompletionCriteria: function(oldValue, newValue) {
            /* eslint-disable no-console */
            console.log('saw a change. ' + this.gameCompletionCriteria.completionType + ' ' + newValue.completionType)
            /* eslint-enable no-console */
            if (this.gameCompletionCriteria.completionType == "PLAYER_OUT") {
                this.$refs.amount_fields.style.display = "none";
            } else {
                this.$refs.amount_fields.style.display = "flex";
            }
        }
    }
}
</script>

<style scoped='true'>
.modal-body {
    max-height: calc(100vh - 210px);
    overflow-y: auto;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
}

/* .modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
 */
.modal-container {
  width: 100%;
  margin: 0px auto;
  background-color: rgba(0,0,0,0);
  border-radius: 2px;
/*   box-shadow: 0 2px 8px rgba(0, 0, 0, .33); */
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  
  display: flex;
  flex-direction: column;
  align-items: center;

    max-height: 100%;
    overflow-y: auto;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}


.game-definition-form-header {
  text-align: center;
  background-color: #F6F7F8;
  border: 1px solid #D6D9DC;
  border-radius: 3px;
  
  width: 80%;
  margin: 40px 0 4px;
  padding: 50px;
}

.game-definition-form-header h1 {
  font-size: 30px;
  margin-bottom: 20px;
}

.game-definition-form {
  background-color: #F6F7F8;
  border: 1px solid #D6D9DC;
  border-radius: 3px;
  
  width: 80%;
  padding: 50px;
  margin: 0 0 40px 0;
}

.form-row {
  margin-bottom: 40px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  flex-wrap: wrap;
}

.form-row input[type='text'],
.form-row input[type='number'] {
  background-color: #FFFFFF;
  border: 1px solid #D6D9DC;
  border-radius: 3px;
  width: 100%;
  padding: 7px;
  font-size: 14px;
}

.form-row label {
  margin-bottom: 15px;
}

.form-row input[type='text']:invalid,
.form-row input[type='number']:invalid {
  border: 1px solid #D55C5F;
  color: #D55C5F;
  box-shadow: none; /* Remove default red glow in Firefox */
}

.legacy-form-row {
  border: none;
  margin-bottom: 40px;
}

.legacy-form-row legend {
  margin-bottom: 15px;
}

.legacy-form-row .radio-label {
  display: block;
  font-size: 14px;
  padding: 0 20px 0 10px;
}

.legacy-form-row input[type='radio'] {
  margin-top: 2px;
}
  
.labeled-radio,
.legacy-form-row .radio-label,
.legacy-form-row input[type='radio'] {
  float: left;
}

.form-row select {
  width: 100%;
  padding: 5px;
  font-size: 14px;            /* This won't work in Chrome or Safari */
  -webkit-appearance: none;   /* This will make it work */
}

.form-row textarea {
  font-family: "Helvetica", "Arial", sans-serif;
  font-size: 14px;

  border: 1px solid #D6D9DC;
  border-radius: 3px;

  min-height: 200px;
  margin-bottom: 10px;
  padding: 7px;
  resize: none;
}

.form-row .instructions {
  color: #999999;
  font-size: 14px;
  margin-bottom: 30px;
}

.form-row .checkbox-label {
  margin-bottom: 0;
}

.form-row button {
  font-size: 16px;
  font-weight: bold;

  color: #FFFFFF;
  background-color: #5995DA;

  border: none;
  border-radius: 3px;

  padding: 10px 40px;
  cursor: pointer;
}

.form-row button:hover {
  background-color: #76AEED;
}

.form-row button:active {
  background-color: #407FC7;
}

@media only screen and (min-width: 700px) {
  .game-definition-form-header,
  .game-definition-form {
    width: 600px;
  }
  .labeled-radio {
    flex-direction: column;
    align-items: flex-start; /* To avoid stretching */
    margin-bottom: 20px;
  }
  .form-row {
    flex-direction: row;
    align-items: flex-start; /* To avoid stretching */
    margin-bottom: 20px;
  }
  .form-row input[type='text'],
  .form-row input[type='number'],    /* Add */
  .form-row select,                 /* These */
  .form-row textarea {
    width: 250px;
    height: initial;
  }
  .form-row label {
    text-align: right;
    width: 120px;
    margin-top: 7px;
    padding-right: 20px;
  }

  .legacy-form-row {
    margin-bottom: 10px;
  }
  .legacy-form-row legend {
    width: 120px;
    text-align: right;
    padding-right: 20px;
    font-size: 1rem;
    float: left;
  }

  .form-row .instructions {
    margin-left: 120px;
  }

  .form-row .checkbox-label {
    margin-left: 120px;
    width: auto;
  }
  
  .form-row checkbox {
    padding-left: 120px;
    width: auto;
  }
  
  .form-row button {
    margin-left: 120px;
  }  
}
</style>